// extracted by mini-css-extract-plugin
module.exports = {"invalid":"Error_invalid__3VinW","valid":"Error_valid__2yGWY"};